import {drawer} from '@cypro/ui/components'
import {Suspense} from 'react'
import {PickingListDrawer, PickingListDrawerProps} from './picking-list-drawer'

function getPickingListDrawerId(drawerId: string) {
  return `picking-list-drawer-${drawerId}`
}

export function openPickingListDrawer(drawerId: string, props: PickingListDrawerProps) {
  const id = getPickingListDrawerId(drawerId)

  try {
    drawer.remove(id)
  } catch {}

  drawer.open(id, {
    id,
    children: (
      <Suspense fallback={null}>
        <PickingListDrawer {...props} />
      </Suspense>
    ),
    expandable: true,
  })
}
